import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    // 예금/대출 목록조회
    selectTSRCAPR11List: {
      in: {
        tSRCAPR11: {
          ovsesPrdctLagClsfiCd: "",
        },
      },
      out: {
        // 예금상품목록
        /*
          operGroupCd             운영그룹코드 
          ovsesBrncoPrdctCd       해외BO상품코드 
          ovsesPpsnCoprDstcd      해외개인법인구분코드 
          ovsesPrdctLagClsfiCd    해외상품대분류코드 
          ovsesPrdctMedmClsfiCd   해외상품중분류코드 
          ovsesPrdctTmpltCd       해외상품템플릿코드 
          prdctHanglName          상품한글명 
          prdctEngName            상품영문명 
          ovsesPrdctLcalName      해외상품현지명 
          prdctBrifHanglCtnt      상품요약한글내용 
          prdctBrifEngCtnt        상품요약영문내용 
          prdctBrifLcalCtnt       상품요약현지내용 
          prdctImgFileID          상품이미지파일ID 
          prdctImgFilePsyclName   상품이미지파일 물리파일명
          prdctImgFileLogicName   상품이미지파일 논리파일명
          prdctImgFilePath        상품이미지파일 경로
          prdctImgFileData        상품이미지파일 Data
          prdctDtailImgFileID     상품상세이미지파일ID 
          wWWJoinYn               인터넷가입여부(0:영업점가입, 1:인터넷가입, 9:전체) 
          prdctBascIrt            상품기본금리 
          aplyStartYmd            적용시작년월일 
          aplyEndYmd              적용종료년월일 
          dsplYn                  디스플레이여부(0:비공개, 1:공개) 
          resizDstcd              거주구분코드(0:구분없음, 1:거주, 2:비거주) 
          frstRegiYMS             최초등록일시 
          lastModfiYMS            최종변경일시 
          lastMdfrID              최종변경자ID 
          joinCncycdArr           가입통화코드 arr
          tSRCAPR14List           가입통화코드 목록
          */
        tSRCAPR11List: new Array(),
      },
    },
    // 예금/대출 상세조회
    selectTSRCAPR11Detail: {
      in: {
        tSRCAPR11: {
          ovsesBrncoPrdctCd: "", // 해외BO상품코드
          ovsesPpsnCoprDstcd: "", // 해외개인법인구분코드
        },
      },
      out: {
        tSRCAPR11Detail: {
          operGroupCd: "" /** 운영그룹코드  **/,
          ovsesBrncoPrdctCd: "" /** 해외BO상품코드  **/,
          ovsesPpsnCoprDstcd: "" /** 해외개인법인구분코드  **/,
          ovsesPrdctLagClsfiCd: "" /** 해외상품대분류코드  **/,
          ovsesPrdctMedmClsfiCd: "" /** 해외상품중분류코드  **/,
          ovsesPrdctTmpltCd: "" /** 해외상품템플릿코드  **/,
          prdctHanglName: "" /** 상품한글명  **/,
          prdctEngName: "" /** 상품영문명  **/,
          ovsesPrdctLcalName: "" /** 해외상품현지명  **/,
          prdctBrifHanglCtnt: "" /** 상품요약한글내용  **/,
          prdctBrifEngCtnt: "" /** 상품요약영문내용  **/,
          prdctBrifLcalCtnt: "" /** 상품요약현지내용  **/,
          prdctImgFileID: "" /** 상품이미지파일 ID  **/,
          prdctImgFilePsyclName: "" /** 상품이미지파일 물리파일명  **/,
          prdctImgFileLogicName: "" /** 상품이미지파일 논리파일명  **/,
          prdctImgFilePath: "" /** 상품이미지파일 경로  **/,
          prdctImgFileData: "" /** 상품이미지파일 Data  **/,
          prdctDtailImgFileID: "" /** 상품상세이미지파일 ID  **/,
          prdctDtailImgFilePsyclName: "" /** 상품상세이미지파일 물리파일명  **/,
          prdctDtailImgFileLogicName: "" /** 상품상세이미지파일 논리파일명  **/,
          prdctDtailImgFilePath: "" /** 상품상세이미지파일 경로  **/,
          prdctDtailImgFileData: "" /** 상품상세이미지파일 Data  **/,
          wWWJoinYn: "" /** 인터넷가입여부(0:영업점가입, 1:인터넷가입, 9:전체)  **/,
          prdctBascIrt: "" /** 상품기본금리  **/,
          aplyStartYmd: "" /** 적용시작년월일  **/,
          aplyEndYmd: "" /** 적용종료년월일  **/,
          dsplYn: "" /** 디스플레이여부(0:비공개, 1:공개)  **/,
          resizDstcd: "" /** 거주구분코드(0:구분없음, 1:거주, 2:비거주)  **/,
          frstRegiYMS: "" /** 최초등록일시  **/,
          lastModfiYMS: "" /** 최종변경일시  **/,
          lastMdfrID: "" /** 최종변경자ID  **/,
          joinCncycdArr: "" /** 가입통화코드 arr  **/,
          privacyCheck: "N", // 약관동의
        },
        /**
          operGroupCd		        운영그룹코드 
          ovsesBrncoPrdctCd		  해외BO상품코드 
          ovsesPpsnCoprDstcd	  해외개인법인구분코드 
          regiSerno		          등록일련번호 
          repntSeq		          표시순서 
          scopDstcd		          영역구분코드(0:메인영역, 1:서브영역) 
          attriHanglCtnt		    속성한글내용 
          attriEngCtnt		      속성영문내용 
          attriLcalCtnt		      속성현지내용 
          attriDtailHanglCtnt		속성상세한글내용 
          attriDtailEngCtnt		  속성상세영문내용 
          attriDtailLcalCtnt		속성상세현지내용 
         */
        tSRCAPR12List: new Array(),
        /*
        operGroupCd             운영그룹코드          
        ovsesBrncoPrdctCd       해외BO상품코드 
        ovsesPpsnCoprDstcd      해외개인법인구분코드 
        brncoLangDstcd          BO언어구분코드 
        stpulFileNo             약관파일번호 
        ovsesStpulFileID        해외약관파일ID 
        stpulFileGroupNo        약관파일그룹번호 
        fileID                  파일ID
        pFileName               물리파일명
        lFileName               논리파일명
        extnName                확장자명
        filePath                파일경로
        fileSize                파일사이즈
        fileDownYN              파일다운여부
        */
        tSRCAPR13List: new Array(),
        tSRCAPR13ListOrdered: new Array(),
        /*
        operGroupCd             운영그룹코드  
        ovsesBrncoPrdctCd       해외BO상품코드 
        ovsesPpsnCoprDstcd      해외개인법인구분코드  
        joinCncycd              가입통화코드 
        minJoinAmt              최소가입금액 
        hgstJoinAmt             최고가입금액 
        joinTrmDdCtnt           가입기간일내용 
        joinTrmMnCtnt           가입기간월내용 
        irtIrtHanglCtnt         금리이율한글내용 
        irtIrtEngCtnt           금리이율영문내용 
        irtIrtLcalCtnt          금리이율현지내용 
        */
        tSRCAPR14List: new Array(),
      },
    },
    // 통화코드 선택 데이터
    selectedTSRCAPR14: {
      operGroupCd: "",
      ovsesBrncoPrdctCd: "",
      ovsesPpsnCoprDstcd: "",
      joinCncycd: "",
      minJoinAmt: "",
      hgstJoinAmt: "",
      joinTrmDdCtnt: "",
      joinTrmMnCtnt: "",
    },
    // 예금신규 예비거래
    RBF0006B00: {
      in: {
        brncoPrdctCd: "", // 상품코드
        prdctName: "", // 상품명
        cncycd: "", // 통화코드
        dpostBal: "", // 신규가입금액
        pwd: "", // 계좌비밀번호
        pwdCnfrm: "", // 새비밀번호확인
        brncoIntPaymtCyclDstcd: "", // 이자지급주기
        autoExpirExtenYn: "", // 자동만기연장여부
        expirExtenFormDstcd: "", // 만기연장종류
        lnkgAcno: "", // 연결계좌번호
        lnkgAcnoAls: "", // 연결계좌명
        lnkgAcnCncycd: "", // 연결계좌통화코드
        indpCnpr: {
          // 가입기간정보
          ctrcTrmUnitDstic: "", // 가입기간구분
          ctrcTrmCnt: "", // 가입기간
        },
        accountingCommon: {
          // 회계공통
          cupldAcno: "", // 출금계좌번호
          cupldAcnoAls: "", // 출금계좌명
          cupldPwd: "", // 출금계좌비밀번호
          fxCncycd: "", // 출금계좌통화코드
        },
        dpostBal1: "", // 신규가입금액1
        dpostBal2: "00", // 신규가입금액2
        _nprotected: "", // 키보드보안 암호화 필드
      },
      out: {
        acno: "", // 신규계좌번호
        brncoPrdctCd: "", // 상품코드
        prdctName: "", // 상품명
        ovsesCustOcntryName: "", // 예금주명
        cncycd: "", // 통화코드
        dpostBal: "", // 신규가입금액
        fxCncycd: "", // 출금통화코드
        fxTranzAmt: "", // 출금금액
        fxzExrt: "", // 적용환율
        rsultFeeAmt: "", // 수수료
        ctrcTrmUnitDstic: "", // 가입기간구분
        ctrcTrmCnt: "", // 가입기간
        basczIrt: "", // 적용이율
        brncoIntPaymtCyclDstcd: "", // 이자지급주기
        newYmd: "", // 신규일자
        expirYmd: "", // 만기일자
        autoExpirExtenYn: "", // 자동만기연장여부
        expirExtenFormDstcd: "", // 만기연장종류
        lnkgAcno: "", // 연결계좌번호
        lnkgAcnoAls: "", // 연결계좌명
        lnkgAcnCncycd: "", // 연결계좌통화코드
        cupldAcno: "", // 출금계좌번호
        cupldAcnoAls: "", // 출금계좌명
        autoTrsaccYmd: "", // 자동이체일자
        pamt: "", // 납입금액
        ctrcAmt: "", // 계약금액
        brncoIntCalcModDstcd: "", // 이자계산방식구분
        fxAnounExrtNth: "", // FX고시환율회차
        openPtimExpirIntAmt: "", // 개설시만기이자금액
        brncoTxCd: "", // 과세코드
        brncoIntCalcOnsdBsdeDsticCd: "", // 이자계산한편양편구분
        brncoIntNodayCalcDstcd: "", // 이자일수계산구분
        dpostIrt: "", // 예금이율
        uuidPwd: "", // 신규계좌비밀번호저장용UUID
        uuidPwdCnfrm: "", // 신규계좌비밀번호확인저장용UUID
        uuidCupldPwd: "", // 출금계좌비밀번호저장용UUID
      },
    },
    // 예금신규 본거래
    RBF0006A00: {
      in: {
        brncoPrdctCd: "", // 신상품코드
        prdctName: "", // 상품명
        cncycd: "", // 통화코드
        dpostBal: "", // 신규가입금액
        pwd: "", // 계좌비밀번호
        pwdCnfrm: "", // 새비밀번호확인
        brncoIntPaymtCyclDstcd: "", // 이자지급주기
        autoExpirExtenYn: "", // 자동만기연장여부
        expirExtenFormDstcd: "", // 만기연장종류
        lnkgAcno: "", // 연결계좌번호
        lnkgAcnoAls: "", // 연결계좌명
        lnkgAcnCncycd: "", // 연결계좌통화코드
        uuidPwd: "", // 신규계좌비밀번호저장용UUID
        uuidPwdCnfrm: "", // 신규계좌비밀번호확인저장용UUID
        uuidCupldPwd: "", // 출금계좌비밀번호저장용UUID
        telgmPwdUseYn: "0", // 1:전문비번, 0:예비거래비번
        indpCnpr: {
          // 가입기간정보
          ctrcTrmUnitDstic: "", // 가입기간구분
          ctrcTrmCnt: "", // 가입기간
        },
        accountingCommon: {
          // 회계공통
          cupldAcno: "", // 출금계좌번호
          cupldAcnoAls: "", // 출금계좌명
          cupldPwd: "", // 출금계좌비밀번호
          fxCncycd: "", // 출금계좌통화코드
        },
        _nprotected: "", // 키보드보안 암호화 필드
      },
      out: {
        acno: "", // 신규계좌번호
        brncoPrdctCd: "", // 상품코드
        prdctName: "", // 상품명
        ovsesCustOcntryName: "", // 예금주명
        cncycd: "", // 통화코드
        dpostBal: "", // 신규가입금액
        fxCncycd: "", // 출금통화코드
        fxTranzAmt: "", // 출금금액
        fxzExrt: "", // 적용환율
        rsultFeeAmt: "", // 수수료
        ctrcTrmUnitDstic: "", // 가입기간구분
        ctrcTrmCnt: "", // 가입기간
        basczIrt: "", // 적용이율
        brncoIntPaymtCyclDstcd: "", // 이자지급주기
        newYmd: "", // 신규일자
        expirYmd: "", // 만기일자
        autoExpirExtenYn: "", // 자동만기연장여부
        expirExtenFormDstcd: "", // 만기연장종류
        lnkgAcno: "", // 연결계좌번호
        lnkgAcnoAls: "", // 연결계좌명
        lnkgAcnCncycd: "", // 연결계좌통화코드
        cupldAcno: "", // 출금계좌번호
        cupldAcnoAls: "", // 출금계좌명
        autoTrsaccYmd: "", // 자동이체일자
        pamt: "", // 납입금액
        ctrcAmt: "", // 계약금액
        brncoIntCalcModDstcd: "", // 이자계산방식구분
        fxAnounExrtNth: "", // FX고시환율회차
        openPtimExpirIntAmt: "", // 개설시만기이자금액
        brncoTxCd: "", // 과세코드
        brncoIntCalcOnsdBsdeDsticCd: "", // 이자계산한편양편구분
        brncoIntNodayCalcDstcd: "", // 이자일수계산구분
        dpostIrt: "", // 예금이율
      },
    },
  };
};

const manageDeposit = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    g001_dpsNV: state => {
      return state.selectTSRCAPR11List.out;
    },
    g002_dpsNV: state => {
      return state.selectTSRCAPR11Detail.out;
    },
    g003_dpsNV: state => {
      return state.RBF0006B00;
    },
    g004_dpsNV: state => {
      return state.RBF0006A00;
    },
    g005_dpsNV: state => {
      return state.selectedTSRCAPR14;
    },
    g002_strBrncoPrdctCd: state => {
      return _.trim(state.selectTSRCAPR11Detail.out.tSRCAPR11Detail.ovsesBrncoPrdctCd).length > 0
        ? _.trim(state.selectTSRCAPR11Detail.out.tSRCAPR11Detail.ovsesBrncoPrdctCd).substring(0, 4)
        : "0000";
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    /**
     * 상품상세 데이터 bind (약관데이터 재조립)
     */
    m001_dpsNV: (state, payload) => {
      payload["tSRCAPR13ListOrdered"] = payload.tSRCAPR13List.reduce(function(r, a) {
        r[a.stpulFileGroupNo] = r[a.stpulFileGroupNo] || [];
        if (a.ovsesStpulFileID !== "") {
          r[a.stpulFileGroupNo].push(a);
        }
        return r;
      }, Object.create(null));
      state.selectTSRCAPR11Detail.out = payload;
    },
  },
  actions: {
    /**
     * 예금상품 목록조회
     * @param {*} context
     * @param {*} payload
     */
    act001_manageDeposit: function(context, payload) {
      return new Promise(resolve => {
        context.state.selectTSRCAPR11List.in.tSRCAPR11 = payload;

        this._vm.$post("/deposit/prdct/DpostPrdctSelectList", context.state.selectTSRCAPR11List.in, response => {
          this._vm.$set(context.state.selectTSRCAPR11List, "out", response);
          resolve("success");
        });
      });
    },
    /**
     * 예금상품 상세조회
     * @param {*} context
     * @param {*} payload
     */
    act002_manageDeposit: function(context, payload) {
      return new Promise(resolve => {
        context.state.selectTSRCAPR11Detail.in.tSRCAPR11 = payload;

        this._vm.$post("/deposit/prdct/DpostPrdctSelectDetail", context.state.selectTSRCAPR11Detail.in, response => {
          // this._vm.$set(context.state.selectTSRCAPR11Detail, "out", response);
          context.commit("m001_dpsNV", response);
          resolve("success");
        });
      });
    },
  },
};

export default manageDeposit;
